import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';
import { getCookie } from '../helpers/Cookies';
import { cstToUTC, getChannel } from '../Common/CommonHelper';
import { IRIS_MARKETING_SLOT_URL, IRIS_BOPIS_TOOLTIP_MESSAGE } from '../Common/CommonConstants';

const getBopisToolTip = () => {
    try {
        const context = RestClient.getContext();
        const channel = getChannel(context);
        // passing querystring
        const requestParams = {
            searchTerm: IRIS_BOPIS_TOOLTIP_MESSAGE,
        };
        const config = {
            url: `${IRIS_MARKETING_SLOT_URL}/s/${IRIS_BOPIS_TOOLTIP_MESSAGE}`,
            apiHost: apiHosts.content,
            params: requestParams,
            excludeVersion: true,
            isXCloudHeaderRequired: true,
            isCMHeaderRequired: false,
            channel,
        };
        if (context.isPreview) {
            const dateValue = cstToUTC(getCookie('DP_PREVIEW_DATE'), context);
            // Check for the Preview Environment Date
            /* istanbul ignore next */
            config.previewDate = (dateValue || new Date()).toISOString();
        }
        return RestClient.get(config).then((json) => json);
    } catch (e) {
        return e;
    }
};

export default getBopisToolTip;
